


















































































import Vue from 'vue';
import TokenRequestViewModel from '../../../services/viewModel/resource/TokenRequestViewModel';

export default Vue.extend({
  auth: false,
  layout: ['layout-exterior', '_exterior'],
  data: () => ({
    mounted: false,
    login: new TokenRequestViewModel(),
    isLoading: false,
    requestError: undefined,
  }),
  computed: {
    redirectPath(): string {
      return this.$route.query.redirect as string;
    },
  },
  mounted() {
    this.mounted = true;
    this.loadQRData();
  },
  methods: {
    loadQRData() {
      const query = this.$router.currentRoute?.query ?? {};
      // eslint-disable-next-line no-unused-vars
      const { username, email, registrationKey } = query as Record<string, string>;
      this.login.userName = username;
    },
    focusOnPassword() {
      const { passwordField } = this.$refs;
      const inputField = (passwordField as Vue).$refs.input;
      (inputField as HTMLElement).focus();
    },
    gotoRegister() {
      Vue.$router.push('/_exterior/register');
    },
    async doLogin() {
      if (!this.login.validate()) {
        return;
      }
      this.requestError = undefined;
      this.isLoading = true;
      try {
        await this.$auth.login(this.login);
        this.isLoading = false;
        if (this.$auth.user?.statusId === 0) {
          Vue.$router.push('/_exterior/verify-user/');
        } else if (this.redirectPath) {
          Vue.$router.push(this.redirectPath);
        } else {
          Vue.$router.push('/');
        }
      } catch (error: any) {
        this.requestError = error;
      }
      this.isLoading = false;
    },
  },
});
